import {
  GET_DEALS,
  GET_DEAL_TRADES,
  DEAL_DETAIL,
  CLOSE_DEAL_SUCCESS,
  CLOSE_DEAL_ERROR,
  START_CLOSE_DEAL,
  RESET_DEAL_DETAIL,
  RESET_PAPER_ACCOUNT,
} from "./types";
import {
  getDealsUrl,
  dealDetailUrl,
  closeDealUrl,
  deleteDealUrl,
  getDealTradesUrl,
  refreshDealUrl,
  resetPaperTradesUrl
} from "./const";
import network from "./network";
import { PaperExchange } from "../Const";

const getRequestGuard = (exchangeId, getState) => {
  const { selectedExchangeId, paperAccountResetVersion } = getState().settings;
  const includesPaper = exchangeId == null || exchangeId === PaperExchange.id;
  return () => getState().settings.selectedExchangeId === selectedExchangeId &&
    (!includesPaper || getState().settings.paperAccountResetVersion === paperAccountResetVersion);
};

export const getDeals = (exchangeId,pageSize,pageNum,status,botId,search) => (dispatch, getState) => {
  const isCurrentRequest = getRequestGuard(exchangeId, getState);
  const params = {
    exchange_id: exchangeId,
    page_size: pageSize,
    page: pageNum,
    status: status,
    bot_id:botId,
    bot_name:search,
    sort_by: 'asc',
  };

  return network.get(getDealsUrl, params, dispatch, getState).then((res) => {
    if (!isCurrentRequest()) return;
    dispatch({
      type: GET_DEALS,
      payload: {
        deals:pageSize?res.data.deals.data:res.data.deals,
        totalDeals:pageSize?res.data.deals.total:0,
        startItem:pageSize?res.data.deals.from:1
      },
    });
  });
};
export const getDealsSearch = (exchangeId,pageSize,pageNum,status,botId,search) => (dispatch, getState) => {
  return new Promise((resolve,reject)=>{
    const params = {
      exchange_id: exchangeId,
      page_size: pageSize,
      page: pageNum,
      status: status,
      bot_id:botId,
      bot_name:search,
      sort_by: 'asc',
    };
  
    network.get(getDealsUrl, params, dispatch, getState).then((res) => {
      resolve(res)
    }).catch((err)=>{
      reject(err)
    }
    );
  })
  
};
export const getTradeSearch = (exchangeId,pageSize,pageNum,status,botId,search) => (dispatch, getState) => {
  return new Promise((resolve,reject)=>{
    const params = {
      exchange_id: exchangeId,
      page_size: pageSize,
      page: pageNum,
      status: status,
      bot_id:botId,
      bot_name:search,
      sort_by: 'asc',
    };
  
    network.get(getDealTradesUrl, params, dispatch, getState).then((res) => {
      resolve(res)
    }).catch((err)=>{
      reject(err)
    }
    );
  })
  
};

export const getDealDetail = (id) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .get(
        dealDetailUrl,
        {
          id,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { deal, message } = res.data;
        if (deal) {
          dispatch({
            type: DEAL_DETAIL,
            payload: deal,
          });
          resolve(deal);
        } else {
          dispatch({
            type: DEAL_DETAIL,
            payload: {},
          });
          reject(message || "Deal not found.");
        }
      })
      .catch((err) => {
        dispatch({
          type: DEAL_DETAIL,
          payload: {},
        });
        reject(String(err));
      });
  });
};

export const closeDeal = (id,exchangeId,pageSize,pageNum,status) => (dispatch, getState) => {
  dispatch({
    type: START_CLOSE_DEAL,
  });

  network
    .post(
      closeDealUrl,
      {
        id,
        status: "cancelled",
        force: 1,
      },
      dispatch,
      getState
    )
    .then((res) => {
      const { code, message } = res.data;
      if (code === 200) {
        dispatch({
          type: CLOSE_DEAL_SUCCESS,
        });
        dispatch(getDeals(exchangeId,pageSize,pageNum,status));
      } else {
        dispatch({
          type: CLOSE_DEAL_ERROR,
          payload: message,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: CLOSE_DEAL_ERROR,
        payload: String(err),
      });
    });
};

export const resetDealDetail = () => (dispatch) => {
  dispatch({
    type: RESET_DEAL_DETAIL,
  });
};

export const deleteDeal = (id,exchangeId,pageSize,pageNum,status,botId,search) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .post(
        deleteDealUrl,
        {
          id,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message } = res.data;
        if (code === 200) {
          dispatch(getDeals(exchangeId,pageSize,pageNum,status,botId,search));
          resolve();
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(String(err));
      });
  });
};
export const getDealTrades = (exchangeId,pageSize,pageNum,status,side,order) => (dispatch, getState) => {
  const isCurrentRequest = getRequestGuard(exchangeId, getState);
  const params = {
    exchange_id: exchangeId,
    page_size: pageSize,
    page: pageNum,
    status: status,
    side: side,
    order_name: order
  };

  return network.get(getDealTradesUrl, params, dispatch, getState).then((res) => {
    if (!isCurrentRequest()) return;
    dispatch({
      type: GET_DEAL_TRADES,
      payload: {
        trade_list:res.data.trades.data,
        totalTrades:res.data.trades.total,
        startItem:res.data.trades.from
      },
    });
  });
};
export const refreshDealStatus = (id,exchangeId,pageSize,pageNum,status) => (dispatch, getState) => {
  return new Promise((resolve, reject) => {
    network
      .post(
        refreshDealUrl,
        {
          deal_id:id,
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, message } = res.data;
        if (code === 200) {
          dispatch(getDeals(exchangeId,pageSize,pageNum,status));
          resolve(message);
        } else {
          reject(message);
        }
      })
      .catch((err) => {
        reject(String(err));
      });
    
  });
};

export const resetPaperTrades = (exchangeId, fullReset = false) => (dispatch, getState) => {
  if (fullReset && exchangeId !== PaperExchange.id) return Promise.reject();

  return new Promise((resolve, reject) => {
    network
      .post(
        resetPaperTradesUrl,
        {
          exchange_id: exchangeId,
          ...(fullReset ? { full_reset: 1 } : {}),
        },
        dispatch,
        getState
      )
      .then((res) => {
        const { code, data, success, message } = res.data;
        if (success || code === 200) {
          if (fullReset) {
            try {
              localStorage.removeItem(`dashboard_assets_cache_${exchangeId}`);
              localStorage.removeItem(`daily_pnl_cache_${exchangeId}`);
            } catch (error) {
              // Storage may be unavailable; the server reset has already succeeded.
            }
            dispatch({ type: RESET_PAPER_ACCOUNT });
          }
          resolve(data?.message || message);
        } else {
          reject(data?.message || message);
        }
      })
      .catch((err) => {
        reject(String(err));
      });
  });
};
